import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from '@env/environment';

export interface IpsosInvoiceImport {
  Id: string;
  OriginalFileName: string;
  Status: number;
  TotalRows: number;
  ErrorCount: number;
  CalculatedTotal: number;
  UploadedAt: string;
  ValidatedAt?: string;
  CompletedAt?: string;
  InvoiceId?: number;
  ErrorMessage?: string;
  RowVersion: string;
}

export interface IpsosInvoiceImportRow {
  RowNumber: number;
  ExternalEmploymentNumber?: string;
  MaskedPersonalNumber: string;
  StartDate?: string;
  EndDate?: string;
  WorkedHours?: number;
  GrossHourlySalary?: number;
  CalculatedAmount?: number;
  WillCreateUser: boolean;
  IsValid: boolean;
  FieldErrors: string[];
}

@Injectable({ providedIn: 'root' })
export class IpsosInvoiceImportService {
  private readonly baseUrl = `${env.hostApi}company/ipsos-invoice-imports`;
  constructor(private http: HttpClient) { }

  list(): Observable<IpsosInvoiceImport[]> { return this.http.get<IpsosInvoiceImport[]>(this.baseUrl); }
  get(id: string): Observable<IpsosInvoiceImport> { return this.http.get<IpsosInvoiceImport>(`${this.baseUrl}/${id}`); }
  rows(id: string): Observable<IpsosInvoiceImportRow[]> { return this.http.get<IpsosInvoiceImportRow[]>(`${this.baseUrl}/${id}/rows`); }
  upload(file: File): Observable<IpsosInvoiceImport> {
    const data = new FormData(); data.append('file', file, file.name);
    return this.http.post<IpsosInvoiceImport>(this.baseUrl, data);
  }
  approve(item: IpsosInvoiceImport): Observable<IpsosInvoiceImport> {
    return this.http.post<IpsosInvoiceImport>(`${this.baseUrl}/${item.Id}/approve`, { RowVersion: item.RowVersion });
  }
  source(id: string): Observable<Blob> { return this.http.get(`${this.baseUrl}/${id}/source`, { responseType: 'blob' }); }
}
